'use client';

import { useSearchParams } from 'next/navigation';
import { FC, Fragment, PropsWithChildren } from 'react';

const ChildrenWrapper: FC<PropsWithChildren> = ({ children }) => {
  const searchParams = useSearchParams();

  return <Fragment key={searchParams.toString()}>{children}</Fragment>;
};

export { ChildrenWrapper };
